/** Primary label for lists, headers, and search results. */
export function debtorDisplayName(matterOrFields = {}) {
  const fields = matterOrFields && typeof matterOrFields === 'object' ? matterOrFields : {};
  const name = String(fields.Debtor_Name ?? fields.debtorName ?? '').trim();
  const company = String(fields.Debtor_Company ?? fields.debtorCompany ?? '').trim();
  return name || company || '';
}

/**
 * Messages inbox / thread title: company name when set, otherwise the person name.
 * Company debtors (with or without a contact) surface the business name first.
 */
export function debtorCompanyPrimaryName(matterOrFields = {}) {
  const fields = matterOrFields && typeof matterOrFields === 'object' ? matterOrFields : {};
  const name = String(fields.Debtor_Name ?? fields.debtorName ?? '').trim();
  const company = String(fields.Debtor_Company ?? fields.debtorCompany ?? '').trim();
  return company || name || '';
}

/**
 * Normalize contact + company for storage.
 * Debtor_Name is NOT NULL in D1, so it always receives contact or company.
 */
export function normalizeDebtorIdentity({ contactName = '', company = '' } = {}) {
  const contact = String(contactName || '').trim();
  const companyName = String(company || '').trim();
  return {
    contact,
    company: companyName,
    ok: Boolean(contact || companyName),
    Debtor_Name: contact || companyName,
    Debtor_Company: companyName || contact,
  };
}

export function debtorIdentityErrorMessage() {
  return 'Enter a company or contact name (at least one is required).';
}
